import { cellText } from './columns';

/**
 * The rows that did not land, as a CSV the person can fix and bring back
 * (KPR-1899): the file's own columns, with What to fix at the end.
 *
 * A file keepr hands out must not run anything in the spreadsheet that opens
 * it. A cell that starts like a formula is kept readable behind an apostrophe,
 * which a spreadsheet reads as "this is text" (OWASP's CSV injection advice;
 * keepr-api utils/confirmersCsv.js does the same). A plain negative number is
 * not a formula and stays one.
 */

const RISKY = /^[=+\-@\t\r]/;
const PLAIN_NUMBER = /^[+-]?\d+(\.\d+)?$/;

export function neutralize(text) {
	const value = String(text ?? '');
	return RISKY.test(value) && !PLAIN_NUMBER.test(value) ? `'${value}` : value;
}

const csvField = text => {
	const value = neutralize(text);
	return /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
};

/**
 * `lines` are failureLines' output. -> the CSV text, a row once however many
 * things are wrong with it, in the file's order. The BOM is what tells Excel
 * this is UTF-8.
 */
export function rowsToFixCsv({ sheet, lines }) {
	const reasons = new Map();
	lines.forEach(line => reasons.set(line.number, [...(reasons.get(line.number) || []), line.words]));
	const header = [...sheet.columns.map(column => column.name), 'What to fix'].map(csvField).join(',');
	const body = sheet.rows
		.filter(row => reasons.has(row.number))
		.map(row => [
			...sheet.columns.map(column => cellText(row.cells[column.index])),
			reasons.get(row.number).join(' '),
		].map(csvField).join(','));
	return `﻿${[header, ...body].join('\r\n')}\r\n`;
}

export const rowsToFixName = fileName => `${String(fileName || 'spreadsheet').replace(/\.[^.]+$/, '')} - rows to fix.csv`;
